import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import _ from 'lodash';

import { OrderPreferenceEnum } from 'Common/FieldEnum';
import { ASSIGN_ORDER_PREFERENCE_FORM_NAME } from 'Common/FormEnum';
import AssignWhKitToSiteAndSiteGroupComponent from './../components/AssignWhKitToSiteAndSiteGroup';
import { SCHOOL } from 'Common/Constants';

class AssignWhKitToSiteAndSiteGroup extends Component {
  onFieldChange = (e, newVal, prevVal, field) => {
    const { setParentState } = this.props;
    if (field === OrderPreferenceEnum.WarehouseKitchen) {
      if (
        prevVal.length &&
        newVal.length &&
        newVal[0].WarehouseSiteId &&
        !_.isEqual(newVal, prevVal)
      ) {
        setParentState({ isReadOnly: false });
      }
    } else {
      if (newVal !== prevVal) {
        setParentState({ isReadOnly: false });
      }
    }
  };
  getTdProps = (state, rowInfo, column, instance) => {
    const { isGroupSelected, id, setParentState, setFormValues } = this.props;
    return {
      onClick: (e, handleOriginal) => {
        if (handleOriginal) {
          handleOriginal();
          if (rowInfo && rowInfo.original) {
            setTimeout(() => {
              setFormValues(rowInfo.original);
              setParentState({
                selectedRowInfo: rowInfo.original,
                isGroupSelected: true,
                id: rowInfo.original[OrderPreferenceEnum.Id],
                isReadOnly: true,
                isResetForm: false,
              });
            }, 0);
          }
        }
      },
      style: {
        color:
          isGroupSelected &&
          rowInfo &&
          rowInfo.original &&
          id === rowInfo.original[OrderPreferenceEnum.Id]
            ? '#df5a17'
            : '',
        fontWeight:
          isGroupSelected &&
          rowInfo &&
          rowInfo.original &&
          id === rowInfo.original[OrderPreferenceEnum.Id]
            ? 'bold'
            : '500',
      },
    };
  };
  getChildTrProps = (state, rowInfo) => {
    const { isGroupSelected, id, setParentState, setFormValues } = this.props;
    return {
      onClick: e => {
        if (rowInfo && rowInfo.original) {
          setFormValues(rowInfo.original);
          setParentState({
            selectedRowInfo: rowInfo.original,
            isGroupSelected: false,
            id: rowInfo.original[OrderPreferenceEnum.Id],
            isReadOnly: true,
            isResetForm: false,
          });
        }
      },
      style: {
        color:
          !isGroupSelected &&
          rowInfo &&
          rowInfo.original &&
          id === rowInfo.original[OrderPreferenceEnum.Id]
            ? '#df5a17'
            : '',
        fontWeight:
          !isGroupSelected &&
          rowInfo &&
          rowInfo.original &&
          id === rowInfo.original[OrderPreferenceEnum.Id]
            ? 'bold'
            : '500',
      },
    };
  };
  removeWarehouseKit = options => {
    const cloneOptions = [...options];
    const { isGroupSelected, id, selectedRowInfo } = this.props;
    if (isGroupSelected && selectedRowInfo) {
      const { Sites } = selectedRowInfo;
      if (Array.isArray(Sites) && Sites.length) {
        _.forEach(Sites, site => {
          site[OrderPreferenceEnum.SiteType] !== SCHOOL &&
            _.remove(cloneOptions, warehouseKitchen => {
              return (
                site[OrderPreferenceEnum.Id] ===
                warehouseKitchen[OrderPreferenceEnum.Id]
              );
            });
        });
      }
    } else {
      selectedRowInfo &&
        selectedRowInfo.SiteType &&
        selectedRowInfo.SiteType !== SCHOOL &&
        _.remove(cloneOptions, warehouseKitchen => {
          return id === warehouseKitchen[OrderPreferenceEnum.Id];
        });
    }
    return cloneOptions;
  };

  render() {
    const {
      loadingSites,
      siteDataSource,
      siteGroupWHData,
      storageLocationData,
      selectedRowInfo,
      expanded,
      setExpandedState,
    } = this.props;
    return (
      <AssignWhKitToSiteAndSiteGroupComponent
        loadingSites={loadingSites}
        siteDataSource={siteDataSource}
        siteGroupWHData={siteGroupWHData}
        storageLocationData={storageLocationData}
        selectedRowInfo={selectedRowInfo}
        expanded={expanded}
        setExpandedState={setExpandedState}
        getTdProps={this.getTdProps}
        getChildTrProps={this.getChildTrProps}
        setFormValues={this.setFormValues}
        onFieldChange={this.onFieldChange}
        removeWarehouseKit={this.removeWarehouseKit}
      />
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  return errors;
};
export const AssignWhKitToSiteAndSiteGroupContainer = reduxForm({
  validate,
  destroyOnUnmount: false,
  form: ASSIGN_ORDER_PREFERENCE_FORM_NAME,
})(AssignWhKitToSiteAndSiteGroup);



// WEBPACK FOOTER //
// ./src/pages/utilities/assignorderpreference/containers/AssignSiteAndSiteGroupContainer.js